import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthLink, AuthShell } from "@/pages/auth/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Choose a new password">
      {done ? (
        <p className="text-sm text-emerald-300" data-testid="reset-success">
          Password updated. <AuthLink to="/login" testid="reset-login-link">Sign in</AuthLink>
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <div>
            <label className="field-label" htmlFor="reset-password">New password</label>
            <input id="reset-password" type="password" minLength={8} required className="field" value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
          </div>
          {error && <p role="alert" className="text-sm text-red-300" data-testid="reset-error">{error}</p>}
          <button type="submit" className="btn-gold w-full" data-testid="reset-submit-button">Update password</button>
        </form>
      )}
    </AuthShell>
  );
}
